import { axiosV1 } from 'interceptors/axios';

import { decryptResponse } from 'utils/token';

type SendTestEmailProps = {
  emailData: any;
  files?: File[];
};

export const sendTestEmail = async ({
  emailData,
  files,
}: SendTestEmailProps) => {
  const formData = new FormData();

  formData.append('data', JSON.stringify(emailData));

  if (files?.length) {
    files.forEach((file) => {
      formData.append('files', file);
    });
  }

  const { data } = await axiosV1.post('/comms/test-email', formData, {
    headers: {
      'content-Type': 'multipart/form-data',
    },
  });

  const decodedData = await decryptResponse(data);

  return decodedData;
};
